module.exports = {
  qqgdscpjypt: "全球高端水产品交易平台（深圳国际金枪鱼交易有限公司）",
};



// WEBPACK FOOTER //
// ./src/lang/zh.js